import { action }          from 'mobx';
import { makeObservable }  from 'mobx';
import { observable }      from 'mobx';

export type FramingQuestion = 'start' | 'limit' | 'zoom';

export class FramingStore {
	@observable question: FramingQuestion | null = null;

	@observable editing = false;

	@observable freeZoom = false;

	constructor() {
		makeObservable(this);
	}

	@action toggle(question: FramingQuestion) {
		this.question = this.question === question ? null : question;
	}

	@action setFreeZoom(freeZoom: boolean) {
		this.freeZoom = freeZoom;
	}

	@action setEditing(editing: boolean) {
		this.editing = editing;
	}
}

export default new FramingStore();
